export default __webpack_public_path__ + "static/N0216-5ad02c034ffaabaa1a65a7e2ae352f59.png";